import { c as _c } from "react/compiler-runtime";
import type { BestOfAwardsOffer, CreditCardOffer } from '@cc-shopping/contracts/cross-site/marketplace/types';
import { BestOfAwardsBanner } from '@cc-shopping/ui/composites/BestOfAwardsBanner';
import { spacing } from '@cc-shopping/ui/theme';
import { Box, Typography } from '@mui/material';
import { getAnalyticsProps } from '../analyticsUtils';
import { SmallScreenLearnMore } from '../SmallScreenLearnMore';
import { Picture } from './Picture';
export const Card = t0 => {
  const $ = _c(29);
  const {
    creditCardOffer,
    rowIndex,
    isBestOfAwardsEnabled: t1,
    showStickyHeader,
    overrideLearnMore,
    isRewardsOrSubprimeRU: t2,
    shouldPrioritizeImage: t3,
    bestOfAwardsOffer
  } = t0;
  const isBestOfAwardsEnabled = t1 === undefined ? false : t1;
  const isRewardsOrSubprimeRU = t2 === undefined ? false : t2;
  const shouldPrioritizeImage = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== creditCardOffer || $[1] !== rowIndex) {
    t4 = getAnalyticsProps(creditCardOffer, rowIndex);
    $[0] = creditCardOffer;
    $[1] = rowIndex;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const analytics = t4;
  const {
    name
  } = creditCardOffer;
  let t5;
  if ($[3] !== bestOfAwardsOffer || $[4] !== isBestOfAwardsEnabled) {
    t5 = isBestOfAwardsEnabled && <BestOfAwardsBanner variant="roundup" roundupVariant="summary-table" bestOfAwardsOffer={bestOfAwardsOffer ?? {}} />;
    $[3] = bestOfAwardsOffer;
    $[4] = isBestOfAwardsEnabled;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== analytics || $[7] !== creditCardOffer || $[8] !== shouldPrioritizeImage) {
    t6 = <Picture ctaAnalytics={analytics} creditCardOffer={creditCardOffer} priority={shouldPrioritizeImage} />;
    $[6] = analytics;
    $[7] = creditCardOffer;
    $[8] = shouldPrioritizeImage;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = spacing(2);
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = showStickyHeader || isRewardsOrSubprimeRU ? "center" : "left";
  let t9;
  if ($[11] !== name || $[12] !== t8) {
    t9 = <Typography marginTop={t7} data-testid="summary-table-card-name" textAlign={t8} variant="textSmall">{name}</Typography>;
    $[11] = name;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t6 || $[15] !== t9) {
    t10 = <Box display="flex" flexDirection="column" alignItems="center">{t6}{t9}</Box>;
    $[14] = t6;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = spacing(2);
    t12 = {
      display: {
        md: "none"
      }
    };
    $[17] = t11;
    $[18] = t12;
  } else {
    t11 = $[17];
    t12 = $[18];
  }
  let t13;
  if ($[19] !== analytics || $[20] !== creditCardOffer || $[21] !== overrideLearnMore) {
    t13 = overrideLearnMore ?? <SmallScreenLearnMore creditCardOffer={creditCardOffer} ctaAnalytics={analytics} />;
    $[19] = analytics;
    $[20] = creditCardOffer;
    $[21] = overrideLearnMore;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13) {
    t14 = <Box><Box marginTop={t11} sx={t12} minHeight="105px">{t13}</Box></Box>;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t10 || $[26] !== t14 || $[27] !== t5) {
    t15 = <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%" width="100%">{t5}{t10}{t14}</Box>;
    $[25] = t10;
    $[26] = t14;
    $[27] = t5;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
};